import type { CurrentSubscriptionDto } from '@bldsoft/cappie/api/wbs'
import type { CurrentSubscription } from '@setplex/tria-api'
import type { ApiType } from '../../../shared/schemas'

import { MediaResolution } from '@setplex/tria-api'
import * as v from 'valibot'

export const SubscriptionSchema = v.object({
  id: v.number(),
  name: v.nullish(v.string()),
  disableCastOption: v.nullish(v.boolean(), false),
  maxQuality: v.nullish(
    v.picklist([
      MediaResolution.HD,
      MediaResolution.SD,
      MediaResolution.FHD,
      MediaResolution._2K as any, // there is no '_2K' value in CurrentSubscriptionDto yet
      MediaResolution._4K,
    ])
  ),
  // Unused fields
  // description: v.nullish(v.string()),
  // platforms: v.nullish(v.array(v.string())) as any, // CurrentSubscriptionDto has strict list of values, but there is no need to validate it now
  // periodUnlimited: v.nullish(v.boolean(), false),
  // subscriptionLengthDays: v.nullish(v.number()),
  // autoPayAllowed: v.nullish(v.boolean(), false),
  // autoPay: v.nullish(v.boolean(), false),
  // currency: v.nullish(v.string()),
  // devicesCount: v.nullish(v.number()),
  // totalPrice: v.nullish(v.number()),
  // activeUntil: v.nullish(DateTimeSchema),
  // allowCellularOnly: v.nullish(v.boolean(), false),
  // allowDolbyAtmos: v.nullish(v.boolean(), false),
}) satisfies ApiType<Partial<CurrentSubscriptionDto>, CurrentSubscription>
